import React, {Component} from 'react';
import {connect} from 'react-redux';
import ArticleForm from "../../components/articles/articleForm";
import {
	articleFormAttachmentRemove, articleFormAttachmentsChange, changeArticleFormInfoState,
	changeArticleFormSettings, requestPostNewArticle
} from "../../actions/articleForm";
import moment from "moment";
import {requestGetArticleAttachment, requestGetSelectedArticle, requestPatchArticle} from "../../actions/articlesList";
import _ from 'lodash';
import { goBack } from 'connected-react-router'
import {_getFileFromBase64} from "../../helpers/functions";
// var download = require('in-browser-download');

class ArticleFormHOC extends Component {

	componentWillMount() {
		let route = this.props.router.location.pathname;
		let splitedRoute = _.split(route, '/', 4);
		if (this.props.router.location.pathname.includes('/articles/edit-article')) {
			this.props.requestGetSelectedArticle(splitedRoute[3])
		}
	}

	componentWillReceiveProps = (nextProps) => {
		if(this.props.articlesList.fetchingDocument && !nextProps.articlesList.fetchingDocument && nextProps.articlesList.failedToGetDocumentMsg === ''){
			_getFileFromBase64(nextProps.articlesList.documentToDownload);
		}
	};

	// getFileFromBase64 = (documentToDownload) => {
	// 	download(documentToDownload.encodedFile, documentToDownload.name, documentToDownload.fileType, 'base64');
	// };
	onDrop = (files) => { //onChange handler for the drop zone component that adds attachments
		for (let fileIndex = 0; fileIndex < files.length; fileIndex++) {
			let alreadyExists = false;
			for (let attachmentIndex = 0; attachmentIndex < this.props.articleForm.attachments.length; attachmentIndex++) {
				if (files[fileIndex].name === this.props.articleForm.attachments[attachmentIndex].name) {
					alreadyExists = true
				}
			}
			if (!alreadyExists) {
				this.getBase64(files[fileIndex])
			}
			else {
				console.log('=====already exists =======')
			}
		}
	};

	//function that transforms the input file to base64 format
	getBase64 = (file) => {
		let reader = new FileReader();
		reader.readAsDataURL(file);
		let attachment = {
			name: file.name,
			encodedFile: '',
			fileType: file.type
		};
		let props = this.props;
		reader.onload = function () {
			attachment = {...attachment, encodedFile: reader.result.substring(reader.result.indexOf("base64,") + 7)};
			props.articleFormAttachmentsChange(attachment);
		};
		reader.onerror = function (error) {
			console.log('Error: ', error);
		};
	};

	onEditorStateChange = (editorState) => {
		this.props.changeArticleFormSettings('editorState', editorState)
	};


	handleSubmit = (evt) => {
		evt.preventDefault();
		let articleForm = this.props.articleForm;
		if (!articleForm.articleBody) { //user has not filled the body of the editor?
			this.props.changeArticleFormSettings('errorMsg', 'Article Body must not be empty.')
		}
		else { //article can be submitted
			let sendBody = {
				title: articleForm.title,
				body: articleForm.articleBody,
				live: articleForm.live,
				attatchmentDtos: articleForm.attachments,
				authorId: this.props.loggedInUserId,
				createdAt: moment().format()
			};
			let editedAttachments = [];
			if(this.props.articleForm.fetchedArticleAttachments.length > 0)
				editedAttachments = [...editedAttachments,...this.props.articleForm.fetchedArticleAttachments.map(attach => {return {id:attach.id}}) ];
			if(this.props.articleForm.attachments.length > 0)
				editedAttachments = [...editedAttachments, ...this.props.articleForm.attachments];
			this.props.router.location.pathname.includes('/articles/edit-article') ?
				this.props.requestPatchArticle(
						{
							title: articleForm.title,
							body: articleForm.articleBody,
							live: articleForm.live,
							attatchmentDtos: editedAttachments,
							id: articleForm.id
						}
				) :
				this.props.requestPostNewArticle(sendBody)
		}
	};

	render() {
		return (
      <ArticleForm
        requestGetArticleAttachment = {this.props.requestGetArticleAttachment}
        goBack={this.props.goBack}
        edit={this.props.router.location.pathname.includes('/articles/edit-article') ? true : false}
        changeArticleFormInfoState={this.props.changeArticleFormInfoState}
        handleSubmit={this.handleSubmit}
        onEditorStateChange={this.onEditorStateChange}
        articleFormAttachmentRemove={this.props.articleFormAttachmentRemove}
        articleForm={this.props.articleForm}
        changeArticleFormSettings={this.props.changeArticleFormSettings}
        onDrop={this.onDrop}
      />
		)
	}

}

const mapStateToProps = (state) => {
	return {
		articleForm: state.articleForm,
		articlesList: state.articlesList,
		loggedInUserId: state.user.loggedInUser.id,
		router: state.router
	}
};

const mapDispatchToProps = (dispatch) => {
	return {
		changeArticleFormSettings: (key, value) => {
			dispatch(changeArticleFormSettings(key, value))
		},
		articleFormAttachmentsChange: (attachment) => {
			dispatch(articleFormAttachmentsChange(attachment))
		},
		articleFormAttachmentRemove: (attachmentIndex) => {
			dispatch(articleFormAttachmentRemove(attachmentIndex))
		},
		requestPostNewArticle: (sendBody) => {
			dispatch(requestPostNewArticle(sendBody))
		},
		changeArticleFormInfoState: (key) => {
			dispatch(changeArticleFormInfoState(key))
		},
		requestGetSelectedArticle: (id) => {
			dispatch(requestGetSelectedArticle(id))
		},
		goBack: () => {
			dispatch(goBack())
		},
		requestPatchArticle: (sendBody) => {
			dispatch(requestPatchArticle(sendBody))
		},
		requestGetArticleAttachment: (payload) => {
			dispatch(requestGetArticleAttachment(payload))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(ArticleFormHOC);
